module.exports = __webpack_public_path__ + "static/img/icon_szh_cgal_ks_sbyc@2x.ae79b38a.png";